var _ellipse, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.0853,
    cy: 11.8509,
    rx: 12.0853,
    ry: 11.8509,
    transform: "matrix(-0.0342217 0.999414 -0.999366 -0.0355907 25.3955 0.845459)",
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0205 18.7012C12.4287 18.7012 11.949 18.2215 11.949 17.6298V7.62978C11.949 7.03804 12.4287 6.55835 13.0205 6.55835H13.2466C13.8384 6.55835 14.3181 7.03804 14.3181 7.62978V17.6298C14.3181 18.2215 13.8384 18.7012 13.2466 18.7012H13.0205ZM8.256 13.8333C7.66427 13.8333 7.18457 13.3536 7.18457 12.7619V12.4887C7.18457 11.897 7.66427 11.4173 8.256 11.4173H18.0199C18.6116 11.4173 19.0913 11.897 19.0913 12.4887V12.7619C19.0913 13.3536 18.6116 13.8333 18.0199 13.8333H8.256Z",
    fill: "#1D2837"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/addIcon.ffc845e2.svg";
export { ForwardRef as ReactComponent };